import React from "react";

const ProfessorsIcon = () => {
  return (
    <svg
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="prompt-icon"
        d="M7.00038 11.7308L2.66704 9.37693V5.7616L0.359375 4.5001L7.00038 0.884766L13.6414 4.5001V9.29493H12.6414V5.05393L11.3337 5.7616V9.37693L7.00038 11.7308ZM7.00038 6.96677L11.5607 4.5001L7.00038 2.03343L2.44004 4.5001L7.00038 6.96677ZM7.00038 10.5924L10.3337 8.79243V6.29493L7.00038 8.11427L3.66704 6.29493V8.79243L7.00038 10.5924Z"
        fill="white"
      />
    </svg>
  );
};

export default ProfessorsIcon;
